import { ALL_ROLES, ONLY_ADMIN, ONLY_CONTRACTOR, ONLY_USER, Roles } from 'constants/roles';
import { PATH } from 'routes/path';

export const drawerItems = [
    {
        label: 'Home',
        link: PATH.ROOT,
        roles: ALL_ROLES,
    },
    {
        label: 'Profile',
        link: PATH.USER_PROFILE,
        roles: ALL_ROLES,
    },
    {
        label: 'Appointments',
        link: PATH.APPOINTMENTS,
        roles: ALL_ROLES,
    },
    {
        label: 'Create an Appointment',
        link: PATH.CREATE_APPOINTMENT,
        roles: ONLY_USER,
    },
    {
        label: 'Proposals',
        link: PATH.PROPOSALS,
        roles: ONLY_CONTRACTOR,
    },
    {
        label: 'Invoices',
        link: PATH.INVOICES,
        roles: ONLY_CONTRACTOR,
    },
    {
        label: 'Dashboard',
        link: PATH.DASHBOARD,
        roles: ONLY_CONTRACTOR,
    },
    {
        label: 'Users',
        link: PATH.USERS,
        roles: ONLY_CONTRACTOR,
    },
    {
        label: 'Settings',
        link: PATH.ADMIN_SETTINGS,
        roles: ONLY_ADMIN,
    },
];
